'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _browser = require('../../../utils/services/browser');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lib
exports.default = function (DecoratedComponent) {
    return function (props) {
        return (0, _browser.isAndroid)() ? _react2.default.createElement(DecoratedComponent, props) : null;
    };
};

// Utils


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/mobile/android/androidOnly.js
// module id = 2210
// module chunks = 0